import { useContext, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { Outlet, useNavigate } from 'react-router-dom';

import { AuthContext } from '../../contexts/AuthContext';

const NoAuthRoute = () => {
  const { isAuthenticated, isLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated && isLoggedIn) {
      navigate('/verify');
    } else if (isAuthenticated && isLoggedIn) {
      navigate('/performance/center');
    }
  }, [isAuthenticated, isLoggedIn, navigate]);

  if (!isAuthenticated && !isLoggedIn) {
    return (
      <Container
        fluid
        className="p-0 h-100 w-100 bg-white"
        style={{ maxHeight: '100%', overflow: 'auto' }}
      >
        <Outlet />
      </Container>
    );
  } else return <></>;
};

export default NoAuthRoute;
